/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  
  import axios from "axios";
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { SEND_REMINDER } from "../graphql";
  import { VApplication } from "../../../application";
  import { usePolicyId } from "../provider";
  
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  export interface ISendReminderMethods extends IPluginMethodMap {
    getSendReminder(args: any): Promise<any>;
  }
  
  export interface SendReminderProps {
    paymentStatus: string;
    amount: string;
    comment: string;
    receipt?: any;
  }
  
  export class SendReminderService implements IAgentPlugin {
    readonly methods: ISendReminderMethods;
    constructor() {
      this.methods = {
        getSendReminder: this.getSendReminder.bind(this),
      };
    }
  
    async getSendReminder(args: SendReminderProps) {
      console.log(`send email inside mutation`, args);
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
      const {userVid} = usePolicyId();
      try {
        if (client) {
          const res = await client.query({
            query: SEND_REMINDER,
            variables: {
              vuid:userVid
            },
            fetchPolicy: "no-cache",
          });
          if (res?.data) {
            return res?.data;
          }
        }
      } catch (err: any) {
        throw err;
      }
    }
  }
  